import { CancellationNonResidentSearchCrumbs } from 'cancellations/constants/cancellation-non-resident-crumbs';
import { Fragment, useCallback } from 'react';
import { createSearchParams, generatePath, useNavigate } from 'react-router-dom';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import SearchPersonSipo, {
  SearchPersonSipoProps,
} from 'shell/components/shared/search-sipo-person';
import { PersonalDataVM } from 'shell/view-models/personal-data';

interface PersonsPageDeathNonResidentProps extends SearchPersonSipoProps {
  addedTitle?: string;
  goBackUrl?: string;
  onSuccess?: (item: PersonalDataVM) => void;
  onSipoPersonSelected?: (item?: PersonalDataVM) => void;
  redirectUrl?: string;
  editSipoUrl?: string;
  isWithoutBreadcrumb?: boolean;
}

const SearchCancellationsForDeathNonResidentePersonSipoPage = ({
  addedTitle,
  goBackUrl,
  onSuccess,
  onSipoPersonSelected,
  isWithoutBreadcrumb,
  redirectUrl = '/cancellazioni/non-residenti/operazione',
  editSipoUrl = '/cancellazioni/non-residenti/persona-sipo',
  initialValues,
}: PersonsPageDeathNonResidentProps): React.ReactElement => {
  const navigate = useNavigate();

  const handleOnSuccess = useCallback(
    (item) => {
      if (onSuccess) {
        onSuccess(item);
      } else {
        navigate({
          pathname: generatePath(redirectUrl || '', {
            idIntestatario: item?.generality?.municipalityIdentifier || '0',
            idSchedaSoggettoANPR: item?.generality?.anprIdentifier || '0',
          }),
          search: `?${createSearchParams({
            codiceFiscale: item?.fiscalCode || '',
            idSchedaSoggettoANPR: item?.generality?.anprIdentifier || '',
            idIntestatario:
              item?.idSchedaSoggetto || item?.generality?.municipalityIdentifier || '',
          })}`,
        });
      }
    },
    [onSuccess, redirectUrl]
  );

  const handleOnSipoSelected = useCallback(
    (item) => {
      if (onSipoPersonSelected) {
        onSipoPersonSelected(item);
      } else {
        navigate(
          {
            pathname: generatePath(editSipoUrl || ''),
            search: `?${createSearchParams({
              idIntestatario:
                item?.idSchedaSoggetto || item?.generality?.municipalityIdentifier || '',
              idSchedaSoggettoANPR: item?.generality?.anprIdentifier || '',
              codiceFiscale: item?.fiscalCode || '',
            })}`,
          },
          {
            state: item,
          }
        );
      }
    },
    [onSipoPersonSelected, editSipoUrl]
  );

  return (
    <Fragment>
      {isWithoutBreadcrumb ? undefined : (
        <Breadcrumbs items={CancellationNonResidentSearchCrumbs} />
      )}
      <SearchPersonSipo
        addedTitle={addedTitle}
        goBackUrl={goBackUrl}
        onSuccess={handleOnSuccess}
        onSipoPersonSelected={handleOnSipoSelected}
        initialValues={initialValues}
      />
    </Fragment>
  );
};

SearchCancellationsForDeathNonResidentePersonSipoPage.displayName =
  'search person sipo page component';

export default SearchCancellationsForDeathNonResidentePersonSipoPage;
